import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized-page',
    template: `UNAUTHORIZED`,
    styles: [],
    standalone: false
})
export class UnauthorizedPageComponent {}
